import LinkButton from "../_atoms/linkbutton";
import { IProjectData, IServiceData } from "@/types/strapi";
import Tag from "../_atoms/tag";
import Link from "next/link";
import { GlowingEffect } from "../ui/glowing-effect";
import Image from "next/image";
import { getImageUrl } from "@/utils/images";
import ServiceArticle from "../_molecules/service_article";
import ProjectArticle from "../_molecules/project_article";

function ServiceGroup({
	title,
	services,
	projects,
}: {
	title: string;
	services?: IServiceData[];
	projects?: IProjectData[];
}) {
	let datas: IServiceData[] | IProjectData[] | undefined = undefined;
	let type = "service";
	if (services && services.length > 0) {
		datas = services as IServiceData[];
	} else if (projects && projects.length > 0) {
		datas = projects as IProjectData[];
		type = "project";
	} else {
		return null;
	}

	return (
		<section className="container py-8 md:py-16">
			<div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
				<div>
					<p className="text-sm font-semibold uppercase tracking-[0.3em] bg-gradient-primary text-transparent  bg-clip-text">
						Catégorie
					</p>
					<h2 className="mt-2 lg:!text-4xl">{title}</h2>
				</div>
			</div>

			<div
				className={`mt-12 grid gap-10 ${
					type === "service" ? "md:grid-cols-2" : ""
				}`}
			>
				{datas.map((item) => {
					if (type === "service") {
						const service = item as IServiceData;
						const title =
							service.Header?.h1 ||
							service.slug.replace(/-/g, " ");

						return (
							<ServiceArticle
								key={service.id}
								service={service}
								title={title}
							/>
						);
					}

					// sinon -> project
					const project = item as IProjectData;
					return (
						<ProjectArticle key={project.id} project={project} />
					);
				})}
			</div>
		</section>
	);
}
export default ServiceGroup;
